<template>
  <Upload
    uploadTitle="上传文件"
    @fileIdCb="(e) => uploadSuccess(e.url)"
    :filetypes="filetypes"
    :fileId="id"
    :accept="accept"
    :maxSize="maxSize"
  >
    <template #explain>
      <slot v-if="$slots.default" />
      <ul v-else slot="tip" class="el-upload__tip">
        <li>
          上传一份已盖章的扫描件，支持PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG文档
        </li>
      </ul>
    </template>
  </Upload>
</template>

<script>
import upload from '@/common/upload/uoload.vue'

export default {
  name: 'FileUpload',
  props: {
    id: String,
    maxSize : {
      type: Number,
      default: () => 1073741824,
    },
    filetypes: {
      type: Array,
      default: () => [
        'pdf',
        'word',
        'doc',
        'docx',
        'rar',
        'zip',
        'gif',
        'png',
        'jpg',
        'jpeg',
        'bmp',
      ],
    },
    accept: {
      type: String,
      default() {
        // 服务器限制只支持一下文件类型，必须为小写
        return '.doc, .docx, .ppt, .pptx, .xls, .xlsx, .pdf, .rtf, .png, .jpg, .jpeg, .gif, .rar, .zip, .gzip, .tar, .xml, .xsl, .txt, .etnd, .bmp, .tif'
      }
    },
  },
  components: {
    Upload: upload,
  },
  methods: {
    uploadSuccess(id) {
      this.$emit('update:id', id)
    },
  },
}
</script>
